import React from 'react';

import IconAccess from '../../Images/Rebranding/IconAccess';
import IconData from '../../Images/Rebranding/IconData';
import IconEvents from '../../Images/Rebranding/IconEvents';
import IconInsights from '../../Images/Rebranding/IconInsights';
import ProPerk from './ProPerk';

const ProSubscription = () => {
  const proPerks = [
    {
      title: 'Access',
      description:
        'Industry-specific org charts for more than 50 companies, built by our reporters for our newsroom and subscribers.',
      logo: <IconAccess className="h-[45px] min-w-[45px] sm:h-[75px] sm:w-[75px]" />,
    },
    {
      title: 'Data',
      description:
        'View a range of custom databases built by our journalists, offering previously unreported insights into startup funding, investors, and more.',
      logo: <IconData className="h-[45px] min-w-[45px] sm:h-[75px] sm:w-[75px]" />,
    },
    {
      title: 'Insights',
      description:
        'Receive a curated weekly briefing from our expert journalists in your inbox every Friday, plus read Pro-exclusive articles and see the results of subscriber surveys.',
      logo: <IconInsights className="h-[45px] min-w-[45px] sm:h-[75px] sm:w-[75px]" />,
    },
    {
      title: 'Events',
      description:
        'Join subscriber-exclusive live conversations with industry experts to understand and navigate the biggest questions in tech and finance.',
      logo: <IconEvents className="h-[45px] min-w-[45px] sm:h-[75px] sm:w-[75px]" />,
    },
  ];

  return (
    <div className="border-0 border-b border-solid border-grayscale-beige py-48 lg:py-64">
      <h2 className="m-0 mb-32 text-center font-suisse-works text-headline-xs text-primary-black sm:mb-48 sm:text-headline-md">
        Your Pro subscription includes:
      </h2>
      <div className="grid grid-cols-1 gap-32 sm:grid-cols-2 sm:gap-x-40 sm:gap-y-24 md:gap-32 lg:gap-x-80 lg:gap-y-64">
        {proPerks.map((perk, index) => (
          <ProPerk key={`${perk.title}-${index}`} {...perk} />
        ))}
      </div>
    </div>
  );
};

export default ProSubscription;
